function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgReview = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 30 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M4.467,3.215C4.467,2.109 3.573,1.215 2.467,1.215C1.36,1.215 0.467,2.109 0.467,3.215L0.467,31.215C0.467,32.322 1.36,33.215 2.467,33.215C3.573,33.215 4.467,32.322 4.467,31.215L4.467,23.215L8.485,22.209C11.054,21.565 13.773,21.865 16.142,23.047C18.904,24.428 22.11,24.597 24.998,23.509L27.167,22.697C27.948,22.403 28.467,21.659 28.467,20.822L28.467,5.347C28.467,3.909 26.954,2.972 25.667,3.615L25.067,3.915C22.173,5.365 18.767,5.365 15.873,3.915C13.679,2.815 11.16,2.54 8.779,3.134L4.467,4.215L4.467,3.215Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgReview);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/review.130da8b5dbf9fcffd9c96e635c955194.svg";